export const mockBondsmanSearchResults: any = {
    'data': {
        'restRequest': '/rest/v1/Bondsman/person/search?last_name=BASS&first_name=&middle_name=&matchType=STARTS_WITH',
        'totalRecords': 6,
        'pageNumber': 1,
        'pageSize': 25,
        'bondsmanList': [
            {
                'stateId': 17990,
                'doiLicenseNumber': '1',
                'lastName': 'BASS',
                'firstName': 'JESSICA',
                'middleName': 'J',
                'address': {
                    'line1': '2963 GRAHTHAM SCHOOL RD',
                    'cityName': 'MT OLIVE',
                    'state': 'NC',
                    'country': 'USA',
                    'zipCode': '28365',
                    'county': 'ALL'
                },
                'registryStatus': 'NOT PROHIBITED',
                'stateRegistryStatusDate': '2017-01-19',
                'bondsmanLicenseTypes': [
                    {
                        'countyRegistryId': 1992,
                        'licenseType': 'RUNNER'
                    },
                    {
                        'countyRegistryId': 1992,
                        'licenseType': 'BAIL AGENT'
                    },
                    {
                        'countyRegistryId': 1992,
                        'licenseType': 'PROFESSIONAL BONDSMAN'
                    }
                ],
                '_links': {
                    'bondsman details': {
                        'href': '/rest/v1/Bondsman/17990'
                    }
                }
            }
        ]
    }
};
export const mockBondsman1WAKE: any = {
    'data': {
        'stateLicenseId': 36861,
        'doiLicenseNumber': '1',  // 0010004653
        'lastName': 'BASS',
        'firstName': 'JESSICA',
        'middleName': 'J',
        'address': {
            'line1': '301 DUFFY DR',
            'line2': '',
            'cityName': 'GOLDSBORO',
            'state': 'NC',
            'country': 'USA',
            'zipCode': '27534',
            'county': 'ALL'
        },
        'stateRegistryStatus': 'PROHIBITED',
        'stateRegistryStatusDate': '2018-11-19',
        'derivedStatusToPostBondsByAgentOrRunner': 'PROHIBITED',
        'derivedProhibitionDateForAgentOrRunner': '2006-11-20',
        'bondsmanLicenseTypes': [{
            'licenseId': 4648,
            'licenseType': 'SURETY INSURANCE COMPANY', // 'PROFESSIONAL BONDSMAN',
            'doiStatus': 'INACTIVE',
            'doiStatusDate': '2003-08-20',
            'bondsmanCountyData': [{
                'countyRegistryId': 3310,
                'countyNumber': '910',
                'countyName': 'WAKE',
                'countyRegistryStatus': 'JUDGMENT PENDING',
                'countyRegistryStatusDate': '2005-12-05',
                'agentForStatus': 'ACTIVE',
                'licenseType': 'SURETY INSURANCE COMPANY',
                'doiStatus': 'ACTIVE',
                'doiLicenseNumber': '0006559914',
                'agentForStateLicenseId': 35990,
                'businessName': 'QCT INS COMP TWO',
                'address': {
                    'line1': '168 CARDERWOODY RD',
                    'line2': '',
                    'cityName': 'STATESVILLE',
                    'state': 'NC',
                    'country': 'USA',
                    'zipCode': '28625',
                    'county': 'ALL'
                },
                'registryStatus': 'PROHIBITED',
                'derivedStatusToPostBondsByAgentOrRunner': 'PROHIBITED',
                'derivedProhibitionDateForAgentOrRunner': '2006-11-20',
                'derivedStatusToPostBondsByProfBondsmanOrInsCo': 'PROHIBITED',
                'derivedProhibitionDateForProfBondsmanOrInsCo': '2006-11-20',
            },
            {
                'countyRegistryId': 3308,
                'countyNumber': '910',
                'countyName': 'WAKE',
                'countyRegistryStatus': 'JUDGMENT PENDING',
                'countyRegistryStatusDate': '2002-05-15',
                'agentForStatus': 'JUDGMENT PENDING',
                'agentForStatusDate': '2003-09-20',
                'licenseType': 'BAIL AGENT',
                'doiStatus': 'INACTIVE',
                'doiStatusDate': '2003-08-20',
                'doiLicenseNumber': '376',
                'agentForStateLicenseId': 35243,
                'businessName': 'ALLEGHENY CASUALTY COMPANY',
                'address': {
                    'line1': '999 9TH ST',
                    'line2': '',
                    'cityName': 'HARRISBURG',
                    'state': 'PA',
                    'country': 'USA',
                    'zipCode': '17105'
                },
                'registryStatus': 'PROHIBITED',
                'derivedStatusToPostBondsByAgentOrRunner': 'PROHIBITED',
                'derivedProhibitionDateForAgentOrRunner': '2016-11-20',
                'derivedStatusToPostBondsByProfBondsmanOrInsCo': 'PROHIBITED',
                'derivedProhibitionDateForProfBondsmanOrInsCo': '2006-11-20'
            }]
        }],
        'links': {
            'bondsman forfeitures': {
                'href': '/rest/v1/bondsmen/forfeitures/10004653'
            }
        },
        'forfeitureIndexList': [{
            'county': 'WAKE',
            'year': '2006',
            'courtType': 'CRIMINAL DISTRICT',
            'seqNumber': '58138',
            'filingType': 'BOND E',
            'judgmentDate': '2007-07-08',
            'judgmentText': 'FINAL AND UNSATISFIED',
            'bondDate': '2006-12-02',
            'bondAmount': '1000.00',
            'suretyRole': 'BAIL AGNT',
            'otherSuretyRole': 'SRTY IC CO',
            'otherSuretyNumber': 3221,
            'motionType': 'SET ASIDE FORFEITURE AFTER JUDGMENT',
            'caseNumber': '03CVM5511',
            'licenseType': 'RUNNER2',
            }, {
            'county': 'WAKE',
            'year': '2006',
            'courtType': 'CRIMINAL DISTRICT',
            'seqNumber': '58138',
            'filingType': 'BOND D',
            'judgmentDate': '2007-07-08',
            'judgmentText': 'FINAL AND UNSATISFIED',
            'bondDate': '2006-12-02',
            'bondAmount': '1000.00',
            'suretyRole': 'BAIL AGNT',
            'otherSuretyRole': 'SRTY IC CO',
            'otherSuretyNumber': 3221,
            'motionType': 'SET ASIDE FORFEITURE AFTER JUDGMENT',
            'caseNumber': '03CVM5510',
            'licenseType': 'RUNNER2',
            }, {
            'county': 'WAKE',
            'year': '2006',
            'courtType': 'CRIMINAL DISTRICT',
            'seqNumber': '58138',
            'filingType': 'BOND C',
            'judgmentDate': '2007-07-08',
            'judgmentText': 'FINAL AND UNSATISFIED',
            'bondDate': '2006-12-02',
            'bondAmount': '1000.00',
            'suretyRole': 'BAIL AGNT',
            'otherSuretyRole': 'SRTY IC CO',
            'otherSuretyNumber': 3221,
            'motionType': 'SET ASIDE FORFEITURE AFTER JUDGMENT',
            'caseNumber': '03CVM5509',
            'licenseType': 'RUNNER2',
            }, {
            'county': 'DURHAM',
            'year': '2006',
            'courtType': 'CRIMINAL DISTRICT',
            'seqNumber': '58147',
            'filingType': 'BOND B',
            'judgmentDate': '2007-07-08',
            'judgmentText': 'FINAL AND UNSATISFIED',
            'bondDate': '2006-12-03',
            'bondAmount': '300.00',
            'suretyRole': 'BAIL AGNT',
            'otherSuretyRole': 'SRTY IC CO',
            'otherSuretyNumber': 3221,
            'motionType': 'SET ASIDE FORFEITURE BEFORE JUDGMENT',
            'caseNumber': '04CVD636'
        }, {
            'county': 'WAKE',
            'year': '2006',
            'courtType': 'CRIMINAL DISTRICT',
            'seqNumber': '58138',
            'filingType': 'BOND A',
            'judgmentDate': '2007-07-06',
            'judgmentText': 'FINAL AND UNSATISFIED',
            'bondDate': '2006-12-02',
            'bondAmount': '1300.00',
            'suretyRole': 'BAIL AGNT',
            'otherSuretyRole': 'SRTY IC CO',
            'otherSuretyNumber': 3221,
            'motionType': 'SET ASIDE FORFEITURE AFTER JUDGMENT',
            'caseNumber': '03CVM5509',
            'licenseType': 'RUNNER2',
        },
        {
            'county': 'WAKE',
            'year': '2006',
            'courtType': 'CRIMINAL DISTRICT',
            'seqNumber': '58138',
            'filingType': 'BOND D',
            'judgmentDate': '2007-07-08',
            'judgmentText': 'PENDING',
            'bondDate': '2006-12-02',
            'bondAmount': '1000.00',
            'suretyRole': 'BAIL AGNT',
            'otherSuretyRole': 'SRTY IC CO',
            'otherSuretyNumber': 3221,
            'motionType': 'SET ASIDE FORFEITURE AFTER JUDGMENT',
            'caseNumber': '03CVM5510',
            'licenseType': 'RUNNER2',
            }, {
            'county': 'WAKE',
            'year': '2006',
            'courtType': 'CRIMINAL DISTRICT',
            'seqNumber': '58138',
            'filingType': 'BOND C',
            'judgmentDate': '2007-07-08',
            'judgmentText': 'PENDING',
            'bondDate': '2006-12-02',
            'bondAmount': '1000.00',
            'suretyRole': 'BAIL AGNT',
            'otherSuretyRole': 'SRTY IC CO',
            'otherSuretyNumber': 3221,
            'motionType': 'SET ASIDE FORFEITURE AFTER JUDGMENT',
            'caseNumber': '03CVM5509',
            'licenseType': 'RUNNER2',
            }, {
            'county': 'DURHAM',
            'year': '2006',
            'courtType': 'CRIMINAL DISTRICT',
            'seqNumber': '58147',
            'filingType': 'BOND B',
            'judgmentDate': '2007-07-08',
            'judgmentText': 'PENDING',
            'bondDate': '2006-12-03',
            'bondAmount': '300.00',
            'suretyRole': 'BAIL AGNT',
            'otherSuretyRole': 'SRTY IC CO',
            'otherSuretyNumber': 3221,
            'motionType': 'SET ASIDE FORFEITURE BEFORE JUDGMENT',
            'caseNumber': '04CVD636'
        },
        {
            'county': 'WAKE',
            'year': '2006',
            'courtType': 'CRIMINAL DISTRICT',
            'seqNumber': '58138',
            'filingType': 'BOND A',
            'judgmentDate': '2007-07-06',
            'judgmentText': 'PENDING',
            'bondDate': '2006-12-02',
            'bondAmount': '1300.00',
            'suretyRole': 'BAIL AGNT',
            'otherSuretyRole': 'SRTY IC CO',
            'otherSuretyNumber': 3221,
            'motionType': 'SET ASIDE FORFEITURE AFTER JUDGMENT',
            'caseNumber': '03CVM5509',
            'licenseType': 'RUNNER2',
        }
    ]
    }
};
export const mockBondsman1VANCE: any = {
    'data': {
        'stateId': 17990,
        'doiLicenseNumber': '1',
        'lastName': 'BASS',
        'firstName': 'JESSICA',
        'middleName': 'J',
        'address': {
            'line1': '2963 GRAHTHAM SCHOOL RD',
            'line22': 'Suite 101',
            'cityName': 'MT OLIVE',
            'state': 'NC',
            'country': 'USA',
            'zipCode': '28365',
            'county': 'ALL'
        },
        'registryStatus': 'NOT PROHIBITED',
        'bondsmanLicenseTypes': [
            {
                'countyRegistryId': 1992,
                'licenseType': 'RUNNER',
                'bondsmanCountyData': [
                    {
                        'countyRegistryId': 174549,
                        'countyNumber': '950',
                        'countyName': 'VANCE',
                        'countyRegistryStatus': 'PROHIBITED',
                        'countyRegistryStatusDate': '2003-08-20',
                        'agentForStatus': 'ACTIVE',
                        'agentForStatusDate': '2003-08-20',
                        'licenseType': 'SURETY INSURANCE COMPANY',
                        'doiStatus': 'ACTIVE',
                        'doiStatusDate': '2003-08-20',
                        'doiLicenseNumber': '1',
                        'lastName': 'BASS',
                        'firstName': 'JESSICA',
                        'middleName': 'K',
                        'businessName': 'QCT INS COMP 10',
                        'address': {
                            'line1': 'ONE NEWARK CENTER,20TH FLOOR',
                            'cityName': 'NEWARK',
                            'state': 'NJ',
                            'country': 'USA',
                            'zipCode': '07102'
                        },
                        'registryStatus': 'NOT PROHIBITED'
                    },
                    {
                        'countyRegistryId': 174653,
                        'countyNumber': '950',
                        'countyName': 'VANCE',
                        'countyRegistryStatus': 'PROHIBITED',
                        'countyRegistryStatusDate': '2003-08-20',
                        'agentForStatus': 'ACTIVE',
                        'agentForStatusDate': '2003-08-20',
                        'licenseType': 'SURETY INSURANCE COMPANY',
                        'doiStatus': 'ACTIVE',
                        'doiLicenseNumber': '2',
                        'lastName': 'BASS',
                        'firstName': 'JESSICA',
                        'middleName': 'L',
                        'businessName': 'QCT INS COMP 11',
                        'address': {
                            'line1': 'P.O. BOX 1116',
                            'cityName': 'MEADVILLE',
                            'state': 'PA',
                            'country': 'USA',
                            'zipCode': '16335-7116'
                        },
                        'registryStatus': 'NOT PROHIBITED'
                    }
                ]
            },
            {
                'countyRegistryId': 1992,
                'licenseType': 'BAIL AGENT',
                'bondsmanCountyData': [
                    {
                        'countyRegistryId': 174549,
                        'countyNumber': '950',
                        'countyName': 'VANCE',
                        'countyRegistryStatus': 'PROHIBITED',
                        'countyRegistryStatusDate': '2003-08-20',
                        'agentForStatus': 'ACTIVE',
                        'agentForStatusDate': '2003-08-20',
                        'licenseType': 'SURETY INSURANCE COMPANY',
                        'doiStatus': 'ACTIVE',
                        'doiLicenseNumber': '2',
                        'lastName': 'BASS',
                        'firstName': 'JESSICA',
                        'middleName': 'M',
                        'businessName': 'QCT INS COMP 12',
                        'address': {
                            'line1': 'ONE NEWARK CENTER,20TH FLOOR',
                            'cityName': 'NEWARK',
                            'state': 'NJ',
                            'country': 'USA',
                            'zipCode': '07102'
                        },
                        'registryStatus': 'NOT PROHIBITED'
                    },
                    {
                        'countyRegistryId': 174653,
                        'countyNumber': '950',
                        'countyName': 'VANCE',
                        'countyRegistryStatus': 'NOT PROHIBITED',
                        'countyRegistryStatusDate': '2003-08-20',
                        'agentForStatus': 'ACTIVE',
                        'agentForStatusDate': '2003-08-20',
                        'licenseType': 'SURETY INSURANCE COMPANY',
                        'doiStatus': 'ACTIVE',
                        'doiLicenseNumber': '3',
                        'lastName': 'BASS',
                        'firstName': 'JESSICA',
                        'middleName': 'N',
                        'businessName': 'QCT INS COMP 13',
                        'address': {
                            'line1': 'P.O. BOX 1116',
                            'cityName': 'MEADVILLE',
                            'state': 'PA',
                            'country': 'USA',
                            'zipCode': '16335-7116'
                        },
                        'registryStatus': 'NOT PROHIBITED'
                    }
                ]
            },
            {
                'countyRegistryId': 1992,
                'licenseType': 'PROFESSIONAL BONDSMAN',
                'bondsmanCountyData': [
                    {
                        'countyRegistryId': 174549,
                        'countyNumber': '950',
                        'countyName': 'VANCE',
                        'countyRegistryStatus': 'NOT PROHIBITED',
                        'countyRegistryStatusDate': '2003-08-20',
                        'agentForStatus': 'ACTIVE',
                        'agentForStatusDate': '2003-08-20',
                        'licenseType': 'SURETY INSURANCE COMPANY',
                        'doiStatus': 'ACTIVE',
                        'doiLicenseNumber': '1',
                        'lastName': 'BASS',
                        'firstName': 'JESSICA',
                        'middleName': 'O',
                        'businessName': 'QCT INS COMP 14',
                        'address': {
                            'line1': 'ONE NEWARK CENTER,20TH FLOOR',
                            'cityName': 'NEWARK',
                            'state': 'NJ',
                            'country': 'USA',
                            'zipCode': '07102'
                        },
                        'registryStatus': 'NOT PROHIBITED'
                    },
                    {
                        'countyRegistryId': 174653,
                        'countyNumber': '950',
                        'countyName': 'VANCE',
                        'countyRegistryStatus': 'NOT PROHIBITED',
                        'countyRegistryStatusDate': '2003-08-20',
                        'agentForStatus': 'ACTIVE',
                        'agentForStatusDate': '2003-08-20',
                        'licenseType': 'SURETY INSURANCE COMPANY',
                        'doiStatus': 'ACTIVE',
                        'doiLicenseNumber': '2',
                        'lastName': 'BASS',
                        'firstName': 'JESSICA',
                        'middleName': 'P',
                        'businessName': 'QCT INS COMP 15',
                        'address': {
                            'line1': 'P.O. BOX 1116',
                            'cityName': 'MEADVILLE',
                            'state': 'PA',
                            'country': 'USA',
                            'zipCode': '16335-7116'
                        },
                        'registryStatus': 'NOT PROHIBITED'
                    }
                ]
            }
        ],
        'forfeitureIndexList': [
            {
                'county': 'DURHAM',
                'year': '2006',
                'courtType': 'CRIMINAL DISTRICT',
                'seqNumber': '58147',
                'filingType': 'BOND A',
                'judgmentDate': '2007-07-07',
                'judgmentText': 'FINAL',
                'bondDate': '2006-12-03',
                'bondAmount': '300.00',
                'suretyRole': 'BAIL AGNT',
                'otherSuretyRole': 'SRTY IC CO',
                'otherSuretyNumber': 3221,
                'motionType': 'SET ASIDE FORFEITURE BEFORE JUDGMENT',
                'caseNumber': '04CVD636'
            },
            {
                'county': 'WAKE',
                'year': '2006',
                'courtType': 'CRIMINAL DISTRICT',
                'seqNumber': '58138',
                'filingType': 'BOND A',
                'judgmentDate': '2007-07-08',
                'judgmentText': 'FINAL',
                'bondDate': '2006-12-02',
                'bondAmount': '1000.00',
                'suretyRole': 'BAIL AGNT',
                'otherSuretyRole': 'SRTY IC CO',
                'otherSuretyNumber': 3221,
                'motionType': 'SET ASIDE FORFEITURE AFTER JUDGMENT',
                'caseNumber': '03CVM5509',
                'licenseType': 'RUNNER2',

            },
            {
                'county': 'WAKE',
                'year': '2006',
                'courtType': 'CRIMINAL DISTRICT',
                'seqNumber': '58138',
                'filingType': 'BOND A',
                'judgmentDate': '2007-07-06',
                'judgmentText': 'FINAL',
                'bondDate': '2006-12-02',
                'bondAmount': '1300.00',
                'suretyRole': 'BAIL AGNT',
                'otherSuretyRole': 'SRTY IC CO',
                'otherSuretyNumber': 3221,
                'motionType': 'SET ASIDE FORFEITURE AFTER JUDGMENT',
                'caseNumber': '03CVM5509',
                'licenseType': 'RUNNER2',

            }
        ]
    }
};




// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/bondsman.mock.ts